"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dependencies = void 0;
/**
 * @description Enum of dependencies tracked in Statuspage
 */
var Dependencies;
(function (Dependencies) {
    Dependencies["Resturant"] = "SpotOn Restaurant";
    Dependencies["OnlineOrdering"] = "SpotOn Online Ordering";
    Dependencies["RestaurantReporting"] = "SpotOn Restaurant Reporting";
    Dependencies["PaymentProcessing"] = "Payment Processing";
    Dependencies["PaymentDeposits"] = "Payment Deposits";
    Dependencies["Poynt"] = "SpotOn Poynt";
    Dependencies["Register"] = "SpotOn Register";
    Dependencies["Website"] = "SpotOn Website";
    Dependencies["Mobile"] = "SpotOn Mobile";
    Dependencies["Terminal"] = "SpotOn Terminal";
    Dependencies["MerchantDashboard"] = "Merchant Dashboard";
    Dependencies["VirtualTerminal"] = "Virtual Terminal";
    Dependencies["MarketingEditor"] = "Marketing Editor";
    Dependencies["Loyalty"] = "Loyalty";
    Dependencies["GiftCards"] = "Gift Cards";
    Dependencies["SupportPhoneLine"] = "Support Phone Line";
})(Dependencies = exports.Dependencies || (exports.Dependencies = {}));
